import { registerSW } from 'virtual:pwa-register';

let swUpdated = false;

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    swUpdated = true;
    console.info('[SW] Update available, activating new service worker');
    if (typeof updateSW === 'function') {
      Promise.resolve(updateSW(true)).catch((error) => {
        swUpdated = false;
        console.error('[SW] Failed to activate updated service worker', error);
        window.location.reload();
      });
    } else {
      console.warn('[SW] updateSW callback missing, forcing reload');
      window.location.reload();
    }
  },
  onRegisterError(error) {
    console.error('[SW] Failed to register service worker', error);
  },
});

if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!swUpdated) {
      console.debug('[SW] controllerchange ignored because no update flag is set');
      return;
    }
    if (refreshing) {
      console.debug('[SW] controllerchange already handled, skipping');
      return;
    }
    refreshing = true;
    console.info('[SW] Controller changed, reloading to apply the latest assets');
    window.location.reload();
  });
  navigator.serviceWorker.addEventListener('error', (event) => {
    console.error('[SW] Service worker error detected', event);
    if (refreshing) {
      return;
    }
    swUpdated = false;
    window.location.reload();
  });
}
